/**
 * Property that must fetched asynchronously because they are too expensive to compute
 */
export const ASYNC_PROPERTY_OPTIONS = new Set([
  'topics'
]);
